import { buildHrefToSubdomain } from '../../utils/buildHrefToSubdomain'

export default function redirectToSubdomain(subdomainName: string) {
  localStorage.setItem('previouslyChosenSubdomain', subdomainName)

  const url = buildHrefToSubdomain(subdomainName)

  location.href = url
}
